import React from "react";
import { useNavigate } from "react-router-dom";

const Register = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("Admin");
        localStorage.removeItem("Blogger");
        console.log(`Logout`);

        // Use a small timeout to ensure localStorage is cleared before navigating
        setTimeout(() => {
            navigate("/batmanAdminpanel", { replace: true });
        }, 100); // 100ms delay to prevent route switching issue
    };
    return (
        <div>
            <div className="flex items-center gap-[5px] font-semibold">
                <button className="mainred" onClick={handleLogout}>
                    Logout
                </button>

            </div>
        </div>
    );
};

export default Register;
